import config from '@config'
import {
  API_METHOD_GET_SUJETS,
  API_METHOD_POST_UPLOAD,
} from '../config/constants'
/* global process */

const buildUrl = (methodId) => {
  let { baseUrl, endpoint, methods } = config.api
  baseUrl += '/'

  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'production') {
    baseUrl = '/'
  }

  if (!baseUrl) {
    throw Error('Could not find baseUrl for fetching')
  }

  if (!endpoint) {
    throw Error('Could not find endpoint for fetching')
  }

  const method = methods[methodId]
  if (!method) {
    throw Error(`Could not find endpoint with id ${methodId}`)
  }

  return `${baseUrl}${endpoint}/${method}`
}

export const getFetchSujets = async () => {
  const url = buildUrl(API_METHOD_GET_SUJETS)
  const response = await fetch(url)
  return (await response.json()).sujets
}

export const postUploadSujet = async (sujetId, base64Str, type) => {
  const url = buildUrl(API_METHOD_POST_UPLOAD)

  const data = new FormData()
  data.append('sujetId', sujetId)
  data.append('imageUpload', base64Str)
  data.append('type', type)
  const response = await fetch(url, {
    method: 'POST',
    body: data,
  })
  const responseContent = await response.json()
  if (response.status !== 200 || !responseContent.success) {
    throw new Error(
      responseContent.error || `Unknown Error. Response ${response.status}`
    )
  }
  return responseContent.compositeImages
}
